import { render } from "./TextWidget.vue?vue&type=template&id=7d47d464&scoped=true"
import script from "./TextWidget.vue?vue&type=script&lang=js"
export * from "./TextWidget.vue?vue&type=script&lang=js"

import "./TextWidget.vue?vue&type=style&index=0&id=7d47d464&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d47d464"]])

export default __exports__